import { render, staticRenderFns } from "./ResendOTP.vue?vue&type=template&id=2ab48013&scoped=true&"
import script from "./ResendOTP.vue?vue&type=script&lang=js&"
export * from "./ResendOTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab48013",
  null
  
)

export default component.exports